import { render, staticRenderFns } from "./NetWorthTile.vue?vue&type=template&id=2af7fc46"
import script from "./NetWorthTile.vue?vue&type=script&lang=js"
export * from "./NetWorthTile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../config/vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports